import React from 'react';
import PropTypes from 'prop-types';

import TourCardBadge from 'app/shared/components/postingPath/TourCard/TourCardBadge';

import {
    IconCheckmarkCircle,
    IconCameraOutline,
    Tooltip,
    TooltipPopper,
    Text,
} from '@zillow/constellation';

import {
    StyledTourCardImage,
    StyledTriggerText,
} from './StyledComponents';

const noop = () => {};

const propTypes = {
    tourState: PropTypes.oneOf(['active', 'inactive', 'empty']),
    imageSrc: PropTypes.string,
    onClick: PropTypes.func,
    isHidden: PropTypes.bool,
    isSelected: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'full']),
};

const defaultProps = {
    tourState: 'empty',
    imageSrc: '',
    onClick: noop,
    isHidden: false,
    isSelected: false,
    size: 'sm',
};

const trigger = (
    <Tooltip
        shouldReturnFocus={true}
        shouldTakeFocus={true}
        shouldTrapFocus={true}
        body={(
            <Text>
                Floor plans with units only show 3d tours at the unit level.
                Please add your 3d tour to individual units to have 3d tours show on our sites.
            </Text>
        )}
    />
);

const TourCardImage = ({
    tourState,
    imageSrc,
    onClick,
    isHidden,
    isSelected,
    size,
}) => (
    <StyledTourCardImage
        md={size === 'md'}
        full={size === 'full'}
        clickable={onClick !== noop}
        onClick={onClick}
    >
        {isHidden && (
            <div className="TourCardImage-overlay">
                <TooltipPopper triggered={trigger}>
                    <StyledTriggerText>Hidden 3D tour</StyledTriggerText>
                </TooltipPopper>
            </div>
        )}
        {!isHidden && <TourCardBadge tourState={tourState} />}
        {isSelected && (
            <div className="TourCardImage-selected">
                <IconCheckmarkCircle size="md" fontColor="brand" />
            </div>
        )}
        {imageSrc ? (
            <div className="TourCardImage-container" style={{ backgroundImage: `url(${imageSrc})` }} />
        ) : (
            <div className="TourCardImage-container">
                <IconCameraOutline size="lg" fontColor="gray500" />
            </div>
        )}
    </StyledTourCardImage>
);

TourCardImage.propTypes = propTypes;
TourCardImage.defaultProps = defaultProps;

export default TourCardImage;
